import React from 'react';
import styled from 'styled-components';

import { monthsStats } from 'modules/health/mockData/mockData';

import MonthsStatsCard from './MonthsStatsCard';

const MonthsStatsSection = () => {
  return (
    <CardsContainer>
      {monthsStats.map(
        ({ title, targetPercent, advice, monthsData, averageScore }) => (
          <MonthsStatsCard
            key={title}
            title={title}
            targetPercent={targetPercent}
            advice={advice}
            monthsData={monthsData}
            averageScore={averageScore}
          />
        )
      )}
    </CardsContainer>
  );
};

const CardsContainer = styled.div`
  display: flex;
  gap: 40px;
  padding-right: 60px;
  padding-left: 60px;
  margin-top: -480px;
  position: relative;
  z-index: 2;
`;

export default MonthsStatsSection;
